import * as React from "react";
import { Event } from "../../../../../../contracts";
import { renderKickOffState } from "../../../EventCard/RenderMethods/renderKickOffState";
import { renderScore } from "../../../EventCard/RenderMethods";
import { BaseDict } from "../../../../dict";

export const renderLiveDetailsMultiview = (event: Event, componentPrefix: string, dict: BaseDict) =>
    <>
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__scores`} data-uat={`div-ev-list-${componentPrefix}-scores`}>
            {renderLiveScoreMultiview(event)}
        </div>
        {event.isInKickOffState && renderKickOffState(event, componentPrefix, dict)}
    </>

const renderLiveScoreMultiview = (event: Event) => {
    const score = {homeScore: event.score.homeScore, awayScore: event.score.awayScore};
    return renderScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard)
}